import React from 'react';

import CTA from '../../../components/CTA';

const ParagraphCta = ({ id, entity }) => {
  const title = entity.getIn(['field_title', 0, 'value']);
  const link = entity.getIn(['field_link', 0, 'alias'], entity.getIn(['field_link', 0, 'uri']));
  const linkTitle = entity.getIn(['field_link', 0, 'title']);
  const linkTarget = entity.getIn(['field_link', 0, 'options', 'attributes', 'target'], '_self');
  const secondaryLink = entity.getIn(['field_link_secondary', 0, 'alias'], entity.getIn(['field_link_secondary', 0, 'uri']));
  const secondaryLinkTitle = entity.getIn(['field_link_secondary', 0, 'title']);
  const secondaryLinkTarget = entity.getIn(['field_link_secondary', 0, 'options', 'attributes', 'target'], '_self');
  const body = entity.getIn(['field_body', 0, 'value']);

  const imageStyles = entity.getIn(['field_media_item', 0, 'styles'], null);

  return (
    <div id={id} className="Paragraph ParagraphCTA">
      <CTA
        title={title}
        body={body}
        link={link}
        linkTitle={linkTitle}
        linkTarget={linkTarget}
        secondaryLink={secondaryLink}
        secondaryLinkTitle={secondaryLinkTitle}
        secondaryLinkTarget={secondaryLinkTarget}
        imageStyles={imageStyles}
      />
    </div>
  );
};

export default ParagraphCta;

